
import { OnboardingOption } from "./types";

export const audiences: OnboardingOption[] = [
  { 
    value: "self", 
    label: "Myself", 
    description: ""
  },
  { 
    value: "team", 
    label: "Teammates", 
    description: ""
  },
  { 
    value: "public", 
    label: "Anyone", 
    description: ""
  }
];

export const privacyOptions: OnboardingOption[] = [
  { 
    value: "public", 
    label: "Public", 
    description: ""
  },
  { 
    value: "private", 
    label: "Private", 
    description: ""
  },
  { 
    value: "exclusive", 
    label: "Exclusive", 
    description: ""
  }
];

export const monetizationOptions: OnboardingOption[] = [
  { 
    value: "free", 
    label: "Free", 
    description: ""
  },
  { 
    value: "paid", 
    label: "Paid", 
    description: ""
  }
];

// Response type selection removed – always first person
export const responseTypeOptions: OnboardingOption[] = [
  { value: "you", label: "As me", description: "" }
];

